var appSettings = {
        base_url: process.env.REACT_APP_ENDPOINT,
        admin_backend_url: process.env.REACT_APP_ASSET_ENDPOINT,
        react_app_endpoint: process.env.REACT_APP_FRONTEND,
        recordsPerPage:10,
        recordsPerPageTable:10,
        stripeKey: process.env.REACT_APP_PUBLISHABLE_KEY,
    }
export default appSettings